<template>
  <div>
    <div class="detailMain">
      <div class="returnBtn" @click="goBack()">
        <i class="el-icon-back"></i>
      </div>
      <el-card shadow="never">
        <div class="cardTop">
          <h1>个人中心</h1>
        </div>
        <div style="margin-top: 20px">

        </div>
        <div class="cardBottom">
          <el-tabs tab-position="left" style="height: 520px;">
            <el-tab-pane label="用户信息">
              <h1>用户信息</h1>
              <el-row class="formRow">
                <el-col :span="24">
                  <div class="grid-content bg-purple">

                    <el-avatar v-if="imageUrl != ''" :size="65" :src="imageUrl"></el-avatar>
                    <el-avatar v-else-if="detailData.sex!=null&&detailData.sex==2" :size="65" :src="sex2"></el-avatar>
                    <el-avatar v-else :size="65" :src="sex1"></el-avatar>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="grid-content bg-purple">
                    <label>用户ID</label> <br />
                    <span>{{detailData.id}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <label>用户名</label> <br />
                    <span>{{detailData.account?detailData.account:"---"}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <label>密码</label> <br />
                    <span>******</span>
                    <el-button type="text" @click="editPwdDialog = true">修改</el-button>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <label>昵称</label> <br />
                    <span>{{detailData.nickName}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <label>性别</label> <br />
                    <span>{{detailData.sex==1?"男":detailData.sex==2?"女":"其他"}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <label>联系电话</label> <br />
                    <span>{{ detailData.phone?detailData.phone:"---" }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <label>联系邮箱</label> <br />
                    <span>{{
                      detailData.email?detailData.email:"---"
                      }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <label>appKey</label> <br />
                    <span>{{
                      detailData.appKey?detailData.appKey:"---"
                      }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <label>appSecret</label> <br />
                    <span>{{
                      detailData.appSecret?detailData.appSecret:"---"
                      }}</span>
                  </div>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-card>
    </div>
    <el-dialog title="修改密码" :visible.sync="editPwdDialog" width="38%" :show-close="false" :close-on-click-modal="false">
      <el-form :model="pwdForm" status-icon :rules="pwdFormRules" ref="pwdForm" label-width="100px">
        <el-form-item label="原始密码" prop="oldPwd">
          <el-input v-model="pwdForm.oldPwd" type="password" style="width:65%"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="userPwd">
          <el-input type="password" v-model="pwdForm.userPwd" style="width:65%" placeholder="建议包含数字，字母，符号至少2种的6位以上组合">
          </el-input>
          <el-rate style="width:32%;display:inline-block" v-model="passwordLevel" :texts="texts" show-text disabled
            :colors="['#F56C6C', '#E6A23C',  '#67C23A']">
          </el-rate>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPwd">
          <el-input type="password" v-model="pwdForm.checkPwd" style="width:65%"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changePwd" :disabled="passwordLevel<3">提交</el-button>
          <el-button @click="resetPwdForm()">重置</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="!pwdLevelIsWeak" @click="editPwdDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import API from "../../api/api";

  export default {
    data() {
      var validateUserPwd = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入新密码（建议包含数字，字母，符号至少2种的6位以上组合）'));
        } else {
          if (this.pwdForm.checkPass !== '') {
            this.$refs.pwdForm.validateField('checkPwd');
          }
          callback();
        }
      };
      var validateCheckPwd = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.pwdForm.userPwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        imageUrl: '',
        sex1: require("../../assets/images/sex1.png"),
        sex2: require("../../assets/images/sex2.png"),
        userName: '',
        pwdForm: {
          id: '',
          oldPwd: '',
          userPwd: '',
          checkPwd: ''
        },
        pwdLevelIsWeak: this.$route.query.pwdWeak, //判断是不密码较弱强制修改
        passwordLevel: 1, //密码强度
        texts: ['极弱', '普通', '中等', '较强', '很强'],
        detailData: {},
        pwdFormRules: {
          oldPwd: [{
            required: true,
            message: "请输入原始密码",
            trigger: "blur"
          }],
          userPwd: [{
            required: true,
            message: "请输入新密码（建议包含数字，字母，符号至少2种的6位以上组合）",
            trigger: "change"
          }],
          checkPwd: [{
            required: true,
            message: "请确认新密码",
            trigger: "blur"
          },
          {
            validator: validateCheckPwd,
            trigger: 'change'
          }
          ],
        },
        editPwdDialog: false, //修改密码模态框
      };
    },
    watch: {
      // 监控路由变化
      "$route": function (to, from) {
        if (to.query && to.query.changePwd) {
          this.editPwdDialog = true
        }
      },
      'pwdForm.userPwd': function (val) {
        this.passwordLevel = this.checkPassword(val)
      }
    },
    created() { },
    methods: {

      getImage(attachId) {
        if (!attachId) return;
        let token = this.$cookies.get('access_token');
        let url = attachId + "&access_token=" + (token ? token : '');
        this.imageUrl = API.download(url)
      },

      init() {
        if (this.$cookies.isKey('access_token')) {
          this.userName = this.$cookies.get('user_name');
          var id = sessionStorage.getItem('uid');
          API.userView(id).then(res => {
            if (res.code == 1) {
              this.detailData = res.data;
              this.getImage(res.data.avatar)
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          road.$confirm('登录用户信息已丢失, 是否重新登陆?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            //确定时
            this.toLogin();
          }).catch(() => {
            //取消时
            this.goBack();
          });
        }
      },
      //提交修改密码
      changePwd() {
        this.$refs.pwdForm.validate((valid) => {
          if (valid) {
            this.pwdForm.id = this.detailData.id
            API.changePwd(this.pwdForm).then(res => {
              if (res.code == 1) {
                this.$refs.pwdForm.resetFields();
                this.editPwdDialog = false
                this.$confirm('密码已成功修改, 是否重新登陆?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.toLogin();
                }).catch(() => {
                  //取消时
                });

              } else {
                this.$message.error(res.msg);
              }
            })
          } else {
            return false;
          }
        });
      },
      resetPwdForm() {
        this.$refs.pwdForm.resetFields();
      },
      //登录
      toLogin() {
        console.log("login..........");
        //确定时
        this.$cookies.remove("access_token");
        sessionStorage.removeItem("menus");
        sessionStorage.removeItem("btns");
        sessionStorage.removeItem("routeList");

        this.$router.push('/');
      }

    },
    mounted() {
      if (this.$route.query.changePwd) {
        this.editPwdDialog = true
      }
      this.init();

    }
  };

</script>


// WEBPACK FOOTER //
// src/views/platform/userPersonal.vue